import { render, staticRenderFns } from "./clue.vue?vue&type=template&id=b1c41ca8&scoped=true"
import script from "./clue.vue?vue&type=script&lang=js"
export * from "./clue.vue?vue&type=script&lang=js"
import style0 from "./clue.vue?vue&type=style&index=0&id=b1c41ca8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c41ca8",
  null
  
)

export default component.exports